export default {
  MASS: 'MASS',
  TICKET: 'TICKET'
}



// WEBPACK FOOTER //
// ./src/components/menus/message/enum/instant_template_message_type.js